<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <FormCity
          :data="city"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          :isNew="!id"
          :language="language"
          @submit="citySubmitHandle"
          @cancel="$router.push({ name: 'page-cities' })"
          @delete-city="deleteCity"
          @language-update="language = $event"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmCityRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import FormCity from './form'
import cityQuery from '@/services/gql/types/City/queries/city.gql'
import updateCityMutation from '@/services/gql/types/City/mutations/updateCity.gql'
import createCityMutation from '@/services/gql/types/City/mutations/createCity.gql'
import deleteCityMutation from '@/services/gql/types/City/mutations/deleteCity.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'

export default {
  name: 'PageCity',
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  components: {
    FormCity,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать город' : 'Создать город'
    }
  },
  computed: {
    isFormLoading () {
      return (
        this.$apollo.queries.city.loading
      )
    },
    isMutationLoading () {
      return this.$async.createCity.$pending ||
        this.$async.updateCity.$pending
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      city: {}
    }
  },
  methods: {
    async deleteCity () {
      try {
        await this.$refs.confirmCityRemoving.open()
        await this.$async.deleteCity.$perform({ id: this.id })
        this.$successMsg('Город удалено')
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении города с ID ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-cities' })
      }
    },
    citySubmitHandle (cityPayload) {
      if (this.id) this.updateCity(cityPayload)
      else this.createCity(cityPayload)
    },
    async createCity ({ data }) {
      try {
        delete data.translations
        await this.$async.createCity.$perform({
          data
        })
        this.$successMsg('Город создан')

        await this.$router.push({ name: 'page-cities' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании города')
      }
    },
    async updateCity ({ data }) {
      try {
        setTranslation(data, this.language)
        await this.$async.updateCity.$perform(
          {
            id: Number(this.id),
            data
          },
          { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) }
        )
        this.$successMsg('Город обновлен')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении города')
      }
    }
  },
  apollo: {
    city: {
      fetchPolicy: 'network-only',
      query: cityQuery,
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      context () {
        return { headers: { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) } }
      },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-cities' })
        } else {
          this.city = {
            ...(res.data?.city || null),
            thumbnailId: res?.data?.city?.thumbnail?.id || null
          }
        }
      }
    }
  },
  async: {
    deleteCity (variables) {
      return this.$apollo.mutate({
        mutation: deleteCityMutation,
        variables
      })
    },
    createCity (variables) {
      return this.$apollo.mutate({
        mutation: createCityMutation,
        variables
      })
    },
    updateCity (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateCityMutation,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
